import { AlertTitle } from "@mui/material";
import { RestrictedAlert } from "@orion/OrionComponents/OrionSnackbar";

import {
  RCS_NOT_ENABLED_REASON,
  RCS_NOT_ENABLED_TITLE,
  useCanUseRcs,
} from "@/api/siteCapabilities";
import { useIsDemoUser } from "@/utils/demoMode";

/**
 * Non-blocking banner shown when a site isn't RCS-approved (FOG-1764). Purely
 * informational — drop it at the top of any text-authoring form (tile or
 * broadcast). Renders nothing when RCS is available. Never restricts what a
 * user can build or save.
 */
export function RcsNotEnabledBanner({ siteId }: { siteId: string }) {
  const canUseRcs = useCanUseRcs(siteId);
  // "Contact your rep" is meaningless to demo prospects.
  const isDemoUser = useIsDemoUser();
  if (canUseRcs || isDemoUser) return null;

  return (
    <RestrictedAlert>
      <AlertTitle sx={{ fontWeight: 700 }}>{RCS_NOT_ENABLED_TITLE}</AlertTitle>
      {RCS_NOT_ENABLED_REASON}
    </RestrictedAlert>
  );
}
